import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { range } from 'es-toolkit';
import { ReactElement } from 'react';
import { FlexBox } from '../../pages/shared-components/flex-box';
import './StepperSkeleton.scss';

interface StepperSkeletonProps {
  stepCount: number;
}

const sectionFieldPlaceholderCount = 6;

const StepperSkeletonImpl = (props: StepperSkeletonProps): ReactElement => {
  const {
    stepCount,
  } = props;

  return (
    <Skeleton
      aria-label='Loading'
      className='stepper-skeleton'
    >
      {
        range(stepCount).map((step) => (
          <FlexBox
            key={step}
            className='stepper-skeleton__row'
          >
            <FlexBox className='stepper-skeleton__nav'>
              <SkeletonItem
                shape='rectangle'
                size={24}
              />
            </FlexBox>
            {
              step === 0 &&
                <FlexBox
                  direction='column'
                  isFullWidth
                  className='stepper-skeleton__section'
                >
                  {
                    range(sectionFieldPlaceholderCount).map((field) => (
                      <SkeletonItem
                        key={field}
                        shape='rectangle'
                        size={40}
                      />
                    ))
                  }
                </FlexBox>
            }
          </FlexBox>
        ))
      }
    </Skeleton>
  );
};

export const StepperSkeleton = StepperSkeletonImpl;
